export const categories = [
  {
    slug: 'liuman-video-dingyi',
    name: '流氓视频定义',
    description: '了解什么是流氓视频、常见的流氓视频类型及其基本特征，建立对恶意视频内容的基础认知。',
    icon: 'ri-virus-line',
    color: 'primary',
  },
  {
    slug: 'shibie-exing-shipin',
    name: '识别恶意视频',
    description: '学习如何准确识别恶意视频链接、虚假视频内容及隐藏的诈骗陷阱，提升辨别能力。',
    icon: 'ri-eye-line',
    color: 'accent',
  },
  {
    slug: 'fangfan-cuoshi',
    name: '防范措施',
    description: '掌握实用的安全防护技巧，从设备设置到浏览习惯全方位守护你的网络安全。',
    icon: 'ri-shield-check-line',
    color: 'secondary',
  },
  {
    slug: 'jubao-weiquan',
    name: '举报与维权',
    description: '了解举报渠道和法律维权途径，勇敢对网络流氓行为说不，维护自身合法权益。',
    icon: 'ri-alert-line',
    color: 'primary',
  },
];